import { Link } from 'react-router-dom';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionTitle({
  title,
  subtitle,
  icon,
  moreTo,
  moreLabel = '查看更多',
}: SectionTitleProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-50 text-primary-600">
            <i className={`${icon} text-lg`}></i>
          </span>
        )}
        <div>
          <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">{title}</h2>
          {subtitle && <p className="mt-0.5 text-xs text-secondary-500 md:text-sm">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-secondary-600 transition-colors hover:text-primary-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-base"></i>
        </Link>
      )}
    </div>
  );
}